import { FC, memo } from 'react'
import { ButtonProps } from '@chakra-ui/react'

import { ButtonWithPermission } from 'components/validators'
import { Trash } from 'components/icons'

type Props = ButtonProps & {
  permissions?: (string | undefined)[]
  customDisableCondition?: boolean
  customTooltipLabel?: string
  children: string
}

const DeleteButtonWithPermission: FC<Props> = ({
  customDisableCondition = null,
  customTooltipLabel = 'Você não tem permissão',
  permissions,
  children,
  ...buttonProps
}) => {
  return (
    <ButtonWithPermission
      customTooltipLabel={customTooltipLabel}
      customDisableCondition={customDisableCondition}
      permissions={permissions}
      leftIcon={<Trash />}
      colorScheme="red"
      variant="outline"
      {...buttonProps}
    >
      {children}
    </ButtonWithPermission>
  )
}

export default memo(DeleteButtonWithPermission)
